import {  ArrayObservable  } from './ArrayObservable';

export const of = ArrayObservable.of;


// WEBPACK FOOTER //
// ./~/rxjs/src/observable/of.ts